import { useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { useSnackbar } from '@shared/hooks/useSnackbar';

export function useErrorSnackbarState() {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const shownForHref = useRef<string | null>(null);

  useEffect(() => {
    const message = location.state.errorSnackbar;
    if (message && location.href !== shownForHref.current) {
      shownForHref.current = location.href;
      enqueueSnackbar(message, { variant: 'error' });
    }
  }, [location.href, location.state.errorSnackbar, enqueueSnackbar]);
}
